import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { API_URL } from '../config';

const BROADCAST_PRODUCT_ID = 'prod_RoHJE5HRxj807D';

export const useSubscriptionStatus = () => {
  const [isSubscriber, setIsSubscriber] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();

  const checkSubscription = async () => {
    if (!isAuthenticated || !user) {
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      setError(null);

      const token = await getAccessTokenSilently();
      const response = await fetch(`${API_URL}/check-subscription`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Failed to check subscription status');
      }

      const data = await response.json();
      setIsSubscriber(data.isSubscriber);
    } catch (error) {
      console.error('Subscription check error:', error);
      setError(error.message);
      setIsSubscriber(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    checkSubscription();
  }, [isAuthenticated, user, getAccessTokenSilently]);

  return {
    isSubscriber,
    isLoading,
    error,
    checkStatus: () => {
      setIsLoading(true);
      checkSubscription();
    }
  };
};
